<template>
<div>
  <div><org-change @orgChange="orgChange"/></div>

  <div>
    <div class="container">
      <title-cop  :title="'社区各检查类型统计'"/>
      <div class="user_status"><type-cop :list="labelList" @change="typeChange"/></div>
    </div>

    <div class="container">
      <title-cop  :title="'社区各网格检查统计'"  :tip="'点击上方检查类型进行切换'" />
      <div class="peple_change"><width-bar :labelName="valueName" :labelCount="valueList" :dataName="typeName" /></div>
    </div>

  </div>
</div>
</template>

<script>
import orgChange from './components/orgChange.vue'
import SexProgress from './components/sex-progress.vue'
import titleCop from './components/title-cop'
import totalNumber from './components/total-Number'
import UserType from './components/userType.vue'
import widthBar from './components/widthBar.vue'
import lineCop from './components/line-cop.vue'
import stackBar from './components/stackBar.vue'
import typeCop from './components/type-cop.vue'
export default {
  components: {
    titleCop,
    totalNumber,
    SexProgress,
    orgChange,
    widthBar,
    UserType,
    lineCop,
    stackBar,
    typeCop
  },
  data () {
    return {
      grid: 0,
      isStreet: true,
      orgList: [],
      dictId: 0,
      typeName: '检查总数',
      labelList: [],
      valueName: [],
      valueList: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    orgChange (id, isStreet) {
      this.grid = id
      this.isStreet = isStreet
      this.init()
    },
    typeChange (index, id, name) {
      if (id) {
        this.dictId = id
        this.typeName = name
        this.init()
      } else {
        this.type = null
        this.dictId = null
        this.typeName = '检查总数'
        this.init()
      }
    },
    init () {
      this.getTypeList()
      this.getComparison()
    },
    getTypeList () {
      this.$http({
        url: this.$http.adornUrl('/wxapp/statistics/check/type'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.$globalData.userInfo.orgId,
          gridId: this.grid || null
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.labelList = [{name: '检查总数', value: 0, unit: '个', img: require('@/assets/img/statistics/check_count.png'), list: []}]
          this.labelList[0].list = data.data.map(item => {
            this.labelList[0].value += item.num
            return {
              name: item.checkTypeName,
              value: item.num,
              id: item.checkType,
              unit: '个'
            }
          })
        } else {
          this.$toast.fail(data.msg)
        }
      })
    },
    getComparison () {
      this.$http({
        url: this.$http.adornUrl('/wxapp/statistics/check/comparison'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.$globalData.userInfo.orgId,
          typeId: this.dictId || null
        })
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.valueName = data.data.map(item => item.name)
          this.valueList = data.data.map(item => item.count)
        } else {
          this.$toast.fail(data.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.topOrgBox {
  padding: 20px 30px;
  .topOrg {
    width: 100%;
    height: 74px;
    text-align: center;
    line-height: 74px;
    margin: 0;
    border-radius: 10px;
    background-color: #fff;
    .pull-icon {
        width: 10px;
    }
  }
}
.container {
  background-color: #fff;
  margin-bottom: 20px;
}
.split_line {
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 2px solid #eee;
}
.user_age {
  height: 500px;
}
.peple_change {
  height: 500px;
}
</style>
